<template>
	<div>
		<!--编辑 -->
		<el-dialog :title="isEdit?'新增课程推荐':'新增课程推荐'" :visible.sync="dialog" @close="unShowClick()" width="30%">
			<el-form ref="addBody" :rules="rules" :model="addBody">
				<el-form-item label="选择课程" prop="name" :label-width="formLabelWidth">
					<el-select style="width: 100%;" v-model="addBody.uuid" placeholder="请选择课程">
						<el-option v-for="item in typeList" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="unShowClick()">取 消</el-button>
				<el-button type="primary" @click="editUser('addBody')">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getCourseList,
		updateCourseRecommend,
		editUser,
		getUser
	} from '@/api/course'
	import ImageUpload from "@/components/ImageUpload"
	// import { getAuthListDetail, identityOf, editAuthUser } from '@/api/auth'

	export default {
		props: {
			uuid: {
				type: Object,
				default: {},
			},
			value: {
				type: Boolean,
				default: false,
			},
			dialogProp: {
				type: Boolean,
				default: false,
			},
		},
		components: {
			ImageUpload
		},
		data() {
			return {
				typeList: [],
				activeName: 'zh',
				readid: '',
				dialog: false,
				identTable: [],
				formLabelWidth: '120px',
				isAddAdmin: true,
				addBody: {
					uuid: ''
				},
				images: [],
				roleUuid: "",
				rules: {
					uuid: [{
						required: true,
						message: '请选择课程',
						trigger: 'blur'
					}, ],
				},
				weightList: [],
				weight: '',
				isEdit: false,
				lmList: [{
						id: 1,
						name: '用户'
					},
					{
						id: 2,
						name: '管理员'
					},
				],
				tabIndex:0
			}
		},
		mounted() {},
		methods: {
			validatePassword(password) {
				const lengthValid = password.length >= 8;
				const hasUpperCase = /[A-Z]/.test(password);
				const hasLowerCase = /[a-z]/.test(password);
				const hasNumber = /\d/.test(password);
				const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
				const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length >= 2;
				return lengthValid && criteriaMet;
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.isEdit) {
							this.network().editUser()
						} else {
							this.network().updateCourseRecommend()
						}
					} else {
						return false;
					}
					return false
				});
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					getUserTableList: async () => {

						let postData = {
							page_size: 9999,
							page_index: 1,
						};
						const {
							status,
							data
						} = await getCourseList(postData);
						if (status !== 200) return;
						this.typeList = data.result.data;
					},
					updateCourseRecommend: async () => {
						if(this.tabIndex==0){
							this.addBody.is_hot = 1
							this.addBody.is_home = 2
							this.addBody.is_quality = 2
						}
						if(this.tabIndex==1){
							this.addBody.is_quality = 1
							this.addBody.is_hot = 2
							this.addBody.is_home = 2
						}
						const {
							status,
							data
						} = await updateCourseRecommend({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('新增成功')
					},
					editUser: async () => {
						const {
							status
						} = await editUser({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
					},
					getUser: async (uuid) => {
						const {
							data,
							status
						} = await getUser({
							uuid: uuid
						})
						if (status !== 200) return
						this.addBody = data.result
					},
				}
			},
		},

		watch: {
			uuid(val) {
				this.network().getUserTableList()
				this.images = []
				this.tabIndex = val.tabIndex
				if (val.uuid) {
					this.isEdit = true;
					this.network().getUser(val.uuid)
				} else {
					this.addBody.uuid = ''
				}
			},
			value(newVal, oldVal) {
				if (newVal !== oldVal) {
					this.dialog = newVal

					this.network().GoodsWeight()
				}
			},
			dialogProp(old) {
				this.dialog = old;
			},
		},
	};
</script>

<style scoped>
</style>